import { action, makeObservable, observable } from "mobx";
import { ODataSearchStore } from "@common/stores";
import { IClientListingModel, IODataSearchResult, ClientListingModel, SearchResponse } from "@common/models";
import { SearchService } from "@common/services/searchService";

export interface IClientSearchFilter {
	emailAddress?: string;
	firstName?: string;
	lastName?: string;
	state?: string;
	microchip?: string;
	palsNumber?: string;
	petName?: string;
	phone?: string;
	rabiesTag?: string;
	cellPhone?: string;
	homePhone?: string;
	alternatePhone?: string;
	hospitalId?: number | undefined;
	clientId?: number | undefined;
}

export const defaultClientSearchFilter: IClientSearchFilter = {
	phone: "",
	firstName: "",
	lastName: "",
	state: "",
	petName: "",
	emailAddress: "",
	microchip: "",
	rabiesTag: "",
	palsNumber: "",
	hospitalId: undefined,
	clientId: undefined,
};

export class ClientSearchStore extends ODataSearchStore<IClientSearchFilter, IClientListingModel, ClientListingModel> {
	@observable noRecordDisclaimer: boolean = true;

	constructor(hospitalId?: number | undefined, searchType: string = "clients") {
		defaultClientSearchFilter.hospitalId = hospitalId;
		super(
			{
				endpointUrl: searchType === "recentvisits" ? SearchService.SearchEndPoints.clientsrecentvisits : SearchService.SearchEndPoints.clients,
				defaultSearchFilter: { ...defaultClientSearchFilter },
				defaultSearchParams: {
					top: 20,
					orderby: searchType === "recentvisits" ? [{ field: "LastVisitDate", dir: "desc" }] : [{ field: "FullName", dir: "asc" }],
				},
			},
			(results: IODataSearchResult<IClientListingModel>) => {
				const classes = results.value?.map(m => new ClientListingModel(m));
				const count = results["@odata.count"];
				return new SearchResponse<ClientListingModel>({ results: classes, totalRecordCount: count });
			}
		);
		makeObservable(this, undefined);
	}

	@action.bound triggerDisclaimer() {
		if (this.noRecordDisclaimer === true && this.searchResults.totalRecordCount === 0) {
			this.noRecordDisclaimer = !this.noRecordDisclaimer;
		}
	}
}
